import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";


export default function DeleteFinanceConfirmModal({onDelete, show, setShow}){




    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Remove Finance Agreement</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"danger"}
                                onClick={onDelete}
                                fullwidth
                            >
                                Delete
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={() => setShow(false)}
                                fullwidth
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )
}